/**
 * Терминал на карточке Custom Software (02_GPT-MODULAR).
 */

import "./SoftwareTerminal.css";

function SoftwareTerminal() {
    return (
                        <div className="software-terminal-card">
                            <div className="software-terminal-header">
                                <span className="software-terminal-title">automation-tool.py</span>
                            </div>
                            
                            <div className="software-terminal-body">
                                <div className="software-terminal-scroll">
                                    {/* Первый набор строк */}
                                    <div className="software-command-line">
                                        <span className="software-prompt">$</span>
                                        <span className="software-command">python automation-tool.py</span>
                                    </div>
                                    <div className="software-output software-output-success">✓ Desktop app initialized</div>
                                    <div className="software-output software-output-success">✓ CLI module loaded</div>
                                    <div className="software-output software-output-success">✓ Background service started</div>
                                    <div className="software-output software-output-processing">⟳ Running data migration...</div>
                                    <div className="software-output software-output-success">✓ Migration completed</div>
                                    <div className="software-output software-output-success">✓ Service deployed</div>
                                    <div className="software-output software-output-success">✓ Tests passed</div>
                                    <div className="software-output software-output-success">✓ Build successful</div>
                                    <div className="software-output software-output-processing">⟳ Restarting...</div>
                                    
                                    {/* Дублируем для бесшовного цикла */}
                                    <div className="software-command-line">
                                        <span className="software-prompt">$</span>
                                        <span className="software-command">python automation-tool.py</span>
                                    </div>
                                    <div className="software-output software-output-success">✓ Desktop app initialized</div>
                                    <div className="software-output software-output-success">✓ CLI module loaded</div>
                                    <div className="software-output software-output-success">✓ Background service started</div>
                                    <div className="software-output software-output-processing">⟳ Running data migration...</div>
                                    <div className="software-output software-output-success">✓ Migration completed</div>
                                    <div className="software-output software-output-success">✓ Service deployed</div>
                                    <div className="software-output software-output-success">✓ Tests passed</div>
                                    <div className="software-output software-output-success">✓ Build successful</div>
                                    <div className="software-output software-output-processing">⟳ Restarting...</div>
                                </div>
                                
                                {/* Progress Bar - Fixed at Bottom */}
                                <div className="software-progress-wrapper">
                                    <div className="software-progress-label">
                                        <span>Processing</span>
                                        <span className="software-percentage">78%</span>
                                    </div>
                                    <div className="software-progress-bar">
                                        <div className="software-progress-fill"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

    );
}

export default SoftwareTerminal;
// components/SoftwareTerminal/SoftwareTerminal.js
